import { LITTLE_GUY_WEBCOMPONENT_FEATURE } from '../constants';

// List of event keys that are used in the application.
const usedEventKeys = new Set([
    'fyd_ddp_visit',
    'global_pageview',
    'fyd_ddp_exit',
    'fyd_srl_visit',
    'fyd_srl_exit',
    'fyd_srl_listing_click',
]);

// List of feature flag keys that are used in the application.
const usedFeatureFlagKeys = new Set([
    'disable_personalization_engine',
    'disable_thirdparty',
    'col_enable_one_trust_footer',
    LITTLE_GUY_WEBCOMPONENT_FEATURE,
    'chat',
    'show_wallet_alert_notification',
    'enable_atc_nav_ai_mode_link',
    // required flag
    'optimizely_snippet',
    'google_analytics',
    'mobile_app_interstitial_test',
]);

const filteredRollouts = (filteredFeatureFlags, rollouts) => {
    const rolloutIds = new Set(
        filteredFeatureFlags.map((f) => f.rolloutId).filter(Boolean),
    );
    return rollouts.filter((r) => rolloutIds.has(r.id));
};

export default function filterOptimizelyData(fullConfig) {
    if (!fullConfig || !fullConfig.dataFile) return null;

    const {
        accountId,
        projectId,
        revision,
        attributes,
        audiences = [],
        version,
        events = [],
        integrations = [],
        anonymizeIP,
        botFiltering,
        typedAudiences = [],
        variables = [],
        environmentKey,
        sdkKey,
        featureFlags = [],
        rollouts = [],
        experiments = [],
        groups = [],
    } = fullConfig.dataFile || {};

    // Get all experiment IDs from experiments and groups
    const allExperimentIds = new Set([
        ...experiments.map((exp) => exp.id),
        ...groups.flatMap((group) => group.experiments?.map((exp) => exp.id) || []),
    ]);

    // Keep feature flags that are:
    // 1. Explicitly used in the application (listed in usedFeatureFlagKeys)
    // 2. OR referenced by any experiment (have experimentIds that match active experiments)
    const filteredFeatureFlags = featureFlags.filter((flag) => {
        const isUsed = usedFeatureFlagKeys.has(flag.key);
        const hasActiveExperiment = flag.experimentIds?.some((expId) => allExperimentIds.has(expId));
        return isUsed || hasActiveExperiment;
    });

    const filteredEvents = events.filter((event) => usedEventKeys.has(event.key));

    const filteredRolloutsArr = filteredRollouts(
        filteredFeatureFlags,
        rollouts,
    );

    return {
        dataFile: {
            accountId,
            projectId,
            revision,
            attributes,
            audiences,
            version,
            integrations,
            anonymizeIP,
            botFiltering,
            typedAudiences,
            variables,
            environmentKey,
            sdkKey,
            experiments,
            groups,
            featureFlags: filteredFeatureFlags,
            events: filteredEvents,
            rollouts: filteredRolloutsArr,
        },
        user: fullConfig.user || {},
        forcedFeatures: fullConfig.forcedFeatures || {},
        forcedExperiments: fullConfig.forcedExperiments || [],
    };
}
